import { all, fork/*, takeEvery, put, call*/ } from "redux-saga/effects";
/*import appActions from "./actions";
import {API_ENDPOINTS} from "../../models/Constants";
import GlobalAxios from "../../helpers/GlobalAxios";*/
export function* functions() {
}

export default function* rootSaga() {
    yield all([fork(functions)]);
}